import { BaseBloc } from '@core/utils/bloc';
import { Repository } from '@core/utils/repository';
import { handleMessage, requestMessage } from '@business/messages';
import { ReviewResponse, ReviewId, CompactReviewResponse, ReviewsRequest } from '@business/entities/review';
import { ReviewAPI } from '@business/api/review';
import { PageQuery } from '@business/entities/common';
import { tap } from 'rxjs/operators';

export class ReviewBloc extends BaseBloc {
  private readonly reviewRepo = new Repository<CompactReviewResponse | ReviewResponse>({
    getItemId: review => review.id,
  });

  readonly reviews$ = this.reviewRepo.items$;
  readonly selectReview = this.reviewRepo.selectItem;

  onReset() {
    this.reviewRepo.reset();
  }

  fetchReviews = (params: ReviewsRequest, reset = false) => {
    // if (reset) {
    //   this.reviewRepo.reset();
    // }
    return ReviewAPI.fetchReviews(params).pipe(
      tap(items => {
        if (items.data.length === 0) {
          return items;
        }
        // this.reviewRepo.reset();
        return this.reviewRepo.addMany(items.data);
      }),
    );
    // return ReviewAPI.fetchReviews(params).pipe(tap(items => this.reviewRepo.addMany(items.data)));
    // return ReviewAPI.fetchReviews(params).pipe(
    //   this.reviewRepo.ops.upsertMany(item => {
    //     console.log('item', item);
    //     return { item };
    //   }),
    // );
  };

  fetchReview = (id: ReviewId) => {
    return ReviewAPI.fetchReview(id).pipe(
      this.reviewRepo.ops.upsertOne(item => ({ item })),
      handleMessage({ error: requestMessage('fetch_reviews_error') }),
    );
  };

  replyReview = (id: ReviewId, data: { body: string }) => {
    return ReviewAPI.replyReview(id, data).pipe(this.reviewRepo.ops.reset(), handleMessage({ type: requestMessage('create_review_reply') }));
  };
}
